import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {DropdownOptionComponent} from './dropdown-option.component';
import {DropdownSelectComponent} from './dropdown-select.component';
import {DropdownSubmenuComponent} from './dropdown-submenu.component';

import {ClickOutsideModule} from '../click-outside/click-outside.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ClickOutsideModule
  ],
  declarations: [
    DropdownSelectComponent,
    DropdownOptionComponent,
    DropdownSubmenuComponent
  ],
  exports: [
    DropdownSelectComponent,
    DropdownSubmenuComponent,
    DropdownOptionComponent
  ],
  providers: []
})
export class DropdownModule {
}
